import {
  defaultSeatTierId,
  seatLabel as catalogSeatLabel,
  seatMax as catalogSeatMax,
  seatTierMap,
} from "@billing/catalog.js";

export const JOURNEY_ORIGIN = "https://dreamhomejourney.online";

/** Apply to every REChecklist anchor that opens DreamHome Journey. */
export const JOURNEY_LINK_PROPS = { target: "_blank", rel: "noreferrer" };

export function journeyOrigin() {
  if (typeof window !== "undefined" && /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname)) {
    return "http://127.0.0.1:5174";
  }
  return JOURNEY_ORIGIN;
}

/** Broker Office seat tiers (10–50 agents). */
export const SEAT_TIERS = seatTierMap();

export function journeyUrl(path, session) {
  const url = new URL(path, `${journeyOrigin()}/`);
  if (session?.role) url.searchParams.set("role", session.role);
  if (session?.userId) url.searchParams.set("user", session.userId);
  if (session?.email) url.searchParams.set("deskEmail", session.email);
  return url.toString();
}

export function manualsUrl(role, session) {
  const path = !role || role === "admin" ? "/manuals" : `/manuals/${role}`;
  return session ? journeyUrl(path, session) : `${journeyOrigin()}${path}`;
}

export function betaOnboardingUrl(session) {
  return session ? journeyUrl("/beta", session) : `${journeyOrigin()}/beta`;
}

export function demoVideoUrl(session) {
  return session ? journeyUrl("/demo", session) : `${journeyOrigin()}/demo`;
}

export function pricingUrl(session) {
  return session ? journeyUrl("/pricing", session) : `${journeyOrigin()}/pricing`;
}

export function supportUrl(session) {
  return journeyUrl("/support", session);
}

export function payUrl(session) {
  const plan = session?.role === "broker" ? "broker" : session?.role === "corporate" ? "corporate" : "agent";
  const url = new URL("/pay", `${journeyOrigin()}/`);
  url.searchParams.set("plan", plan);
  const tier = session?.seat_tier || defaultSeatTierId();
  if (session?.role === "broker") url.searchParams.set("tier", tier);
  if (session?.role) url.searchParams.set("role", session.role);
  if (session?.userId) url.searchParams.set("user", session.userId);
  return url.toString();
}

export function postLoginPath(session, intendedRole) {
  if (!session) return "/login";
  if (session.role === "admin") return "/admin";
  if (session.role === "broker" || session.role === "corporate") return "/broker/dashboard";
  if (session.role === "agent") return "/agent/dashboard";
  if (session.role === "seller") return "/seller/home";
  return "/start";
}

export function seatLabel(tier) {
  return catalogSeatLabel(tier);
}

export function seatMax(tier) {
  return catalogSeatMax(tier);
}
